import { render, staticRenderFns } from "./SdsSection8ACGIHForm.vue?vue&type=template&id=58771e52"
import script from "./SdsSection8ACGIHForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsSection8ACGIHForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports